<template>
  <header
    id="main_header"
    class="flex-vcenter"
  >
    <ButtonClassic
      v-tooltip="{
        content: expandedSidebar ? $t('action.reduire-menu-lateral') : $t('action.deplier-menu-lateral'),
        delay: { show: 800, },
      }"
      v-matomo-log-click="['collapse', ]"
      variant="special"
      :color="darkMode ? 'white' : 'primary'"
      icon="left"
      size="small"
      :disabled="forbiddenMode"
      @click="$emit('toggle-sidebar')"
    >
      <template #left-icon>
        <UilEllipsisV />
      </template>
    </ButtonClassic>

    <!-- @slot Emplacement pour la recherche. -->
    <slot name="search-form" />

    <div
      id="user_profile"
      class="flex-vcenter"
    >
      <!-- @slot Emplacement pour des composants à gauche du avatar button. -->
      <slot name="additional-left-avatar" />

      <AvatarButton
        :open="isAvatarPopoverOpen"
        :user="user"
        :notifications="notifications"
        :dark-mode="darkMode"
        :infos-user="infosUser"
        @clear-notifications="$emit('clear-notifications')"
        @disconnect="$emit('disconnect')"
        @read="$emit('read-notification', $event)"
        @toggle="$emit('avatar-popover-toggle', $event)"
      >
        <template #options>
          <!-- @slot Emplacement pour les options dans AvatarButton. -->
          <slot name="avatar-button-options" />
        </template>
        <template #other>
          <!-- @slot Emplacement pour d'autres éléments dans AvatarButton. -->
          <slot name="avatar-button-other" />
        </template>
      </AvatarButton>
    </div>
  </header>
</template>

<script>
import ButtonClassic from "../../components/buttons/ButtonClassic.vue";
import AvatarButton from "../../components/avatar/AvatarButton.vue";

import { UilEllipsisV } from "@iconscout/vue-unicons";

/**
 * Affiche le header du site. Celui-ci regroupe de nombreux composants accessibles de partout.
 */
export default {
  name: "MainHeader",
  components: {
    ButtonClassic,
    AvatarButton,
    UilEllipsisV,
  },
  props: {
    /**
     * Définit si le menu latéral est réduit ou non.
     */
    expandedSidebar: {
      type: Boolean,
      default: true,
    },
    /**
     * Définit si le mode nuit est activé.
     */
    darkMode: {
      type: Boolean,
      default: false,
    },
    /**
     * Définit si le mode restreint est activé.
     */
    forbiddenMode: {
      type: Boolean,
      default: false,
    },
    /**
     * Contient le nombre et le détail des notifications.
     */
    notifications: {
      type: Object,
      default: () => ({}),
    },
    /**
     * Information sur l'utilisateur à mettre dans le AvatarButton.
     */
    infosUser: {
      type: Array,
      default: () => [],
    },
    /**
     * Information de l'utilisateur courant
     */
    user: {
      type: Object,
      required: true,
    },
    /**
     * Définit si le popover du AvatarButton est ouvert.
     */
    isAvatarPopoverOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    /**
     * Déclenché au toggle de la sidebar.
     */
    "toggle-sidebar",
    /**
     * Déclenché quand on vide les notifications.
     */
    "clear-notifications",
    /**
     * Déclenché au clic sur le bouton de déconnexion.
     */
    "disconnect",
    /**
     * Déclenché au clic sur une notification.
     */
    "read",
    /**
     * Déclenché à l'ouverture/fermeture du popover AvatarButton.
     */
    "avatar-popover-toggle",
  ],
};
</script>

<style lang="scss">
@use "../../assets/styles/components/layout/main_header.scss";
</style>
